export const emailUs = (contactEmail?: string) => {
  if (!contactEmail) {
    alert("Client portal has no contact email configured");
    return;
  }

  window.location.href = `mailto:${contactEmail}`;
};
